import { Component, OnInit } from "@angular/core";
import { PriLoginService } from "./../service/pri-login.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-authorize",
  templateUrl: "./authorize.component.html",
  styleUrls: ["./authorize.component.scss"],
})
export class AuthorizeComponent implements OnInit {
  loginMessage = {
    errorMessage: "",
    successMessage: "Login successful",
  };

  constructor(
    private readonly priLoginService: PriLoginService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.priLoginService.loginMessage.subscribe((res: any) => {
      this.loginMessage = res;
    });
  }
}
